import { SxProps, Theme, alpha } from "@mui/material/styles";
import { UseMaterialColors } from "lib/hooks";

export const GetTextFieldStyle = (): SxProps<Theme> => {
    const materialColors = UseMaterialColors()

    return {
        width: "100%",
        "& .MuiInputBase-root": {
            backgroundColor: materialColors.surfaceBright,
            borderRadius: "8px !important",
            transition: "border-color 0.2s ease",
            borderColor: materialColors.outline,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${materialColors.outline}`,
            borderRadius: "8px !important",
        },
        // Hover / focus states only when not disabled
        "& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${alpha(materialColors.primary, 0.99)}`,
        },
        "& .MuiInputBase-root.Mui-focused:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${alpha(materialColors.primary, 0.5)}`,
        },
        "& .MuiInputBase-input": {
            padding: "10px 12px",
            fontSize: "0.875rem",
            color: materialColors.onSurface,
            "&::placeholder": {
                color: alpha(materialColors.onSurfaceVariant, 0.9),
            },
        },
        "& .MuiInputLabel-root": {
            fontSize: "0.75rem",
            color: alpha(materialColors.onSurfaceVariant, 0.7),
        },
        "& .MuiInputLabel-root.Mui-focused:not(.Mui-disabled)": {
            color: materialColors.primary,
        },
        "& .MuiSvgIcon-root": {
            color: alpha(materialColors.onSurfaceVariant, 0.7),
        },
        "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: materialColors.error,
        },
        "&.Mui-error .MuiInputLabel-root": {
            color: materialColors.error,
        },

        "& .MuiInputBase-inputMultiline": {
            padding: "1px 2px !important",
            lineHeight: 1.4,
            resize: "none",
            boxSizing: "border-box",
        },
    }
}

// New: consistent style for MUI Select (FormControl + OutlinedInput + Label)
export const GetSelectStyle = (): SxProps<Theme> => {
    const materialColors = UseMaterialColors();

    return {
        width: "100%",

        // Input root
        "& .MuiOutlinedInput-root": {
            backgroundColor: materialColors.surfaceBright,
            borderRadius: "8px !important",
            transition: "border-color 0.2s ease",
        },
        // Border
        "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${materialColors.outline}`,
            borderRadius: "8px !important",
        },
        // Hover/focus border
        "& .MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${alpha(materialColors.primary, 0.99)}`,
        },
        "& .MuiOutlinedInput-root.Mui-focused:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${alpha(materialColors.primary, 0.5)}`,
        },

        // Selected text area
        "& .MuiSelect-select": {
            padding: "10px 12px",
            fontSize: "0.875rem",
            color: materialColors.onSurface,
        },

        // Label
        "& .MuiInputLabel-root": {
            fontSize: "0.75rem",
            color: alpha(materialColors.onSurfaceVariant, 0.7),
        },
        "& .MuiInputLabel-root.Mui-focused:not(.Mui-disabled)": {
            color: materialColors.primary,
        },

        // Icons (dropdown arrow)
        "& .MuiSvgIcon-root, & .MuiSelect-icon": {
            color: alpha(materialColors.onSurfaceVariant, 0.7),
        },

        // Error states
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: materialColors.error,
        },
        "& .MuiInputLabel-root.Mui-error": {
            color: materialColors.error,
        },
    };
};